<template>
  <div class="detail-cnt">
    <header class="inner-head">
      <span class="icon-Btn" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <path
            d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
          />
        </svg>
      </span>

      <h2>{{$t('taskDetail')}}</h2>
    </header>

    <section class="mid-cnt">
      <div class="dtl-postbox">
        <h1>{{taskDetail.title}}</h1>
        <div class="info-box" v-if="taskDetail.delivery_time">
          <h2>{{$t('taskCompletionTime')}}:</h2>
          <p>{{ taskDetail.delivery_time.slice(0, taskDetail.delivery_time.indexOf('T')) }}</p>
        </div>
        <div class="info-box" v-if="taskDetail.task_fam !== 'Courier91'">
          <h2>{{$t('earning')}}:</h2>
          <p>&#8377; {{taskDetail.payment}} {{$t('perTaskCompleted')}}</p>
        </div>
        <div class="info-box" v-if="taskDetail.task_fam !== 'Courier91'">
          <h2>{{$t('totalAvailableTask')}}:</h2>
          <p>{{Math.trunc(taskDetail.no_of_task - taskDetail.number_of_task_accepted)}}</p>
        </div>

        <div class="info-box" v-if="taskDetail.task_fam !== 'Courier91'">
          <h2>{{$t('totalCompletedTask')}}:</h2>
          <p>{{taskDetail.no_of_task_completed}}</p>
        </div>
      </div>
      <div
        class="how-workbox"
        v-if="taskDetail.task_details && taskDetail.task_details[0].length > 0"
      >
        <h3>{{$t('howToCompleteTasks')}}</h3>
        <div v-html="(taskDetail.task_details[0][0].text)"></div>

        <div v-if="taskDetail.task_fam === 'Mall91 Sales'" class="go-to-prod">
          <button type="button" @click="goToProdOpen(taskDetail.deep_link)">{{$t('goToProduct')}}</button>
        </div>
      </div>
      <div
        v-if="taskDetail.task_fam === 'Call Center' && ([1,2].includes(callStatus.status) || !callStatus.hasOwnProperty('id'))"
        class="go-to-prod"
      >
        <div v-if="isEligible.eligible_for == false" class="payment-option">
          <ul style="margin-top: -8px;">
            <li class="custom-checkbox">
              <div @click="selectMode('PAYTM')">
                <span class="check-mark" :class="{'active' :!activePaymentMode }"></span>
                <span class="name">Paytm Payment</span>
                <span class="card-img">
                  <img src="../assets/images/paytm.svg" alt />
                </span>
              </div>
            </li>
            <li class="custom-checkbox">
              <div @click="selectMode('NETBANKING')">
                <span class="check-mark" :class="{'active' :activePaymentMode }"></span>
                <span class="name">Debit card / Netbanking</span>
                <span class="card-img">
                  <img src="../assets/images/credit-card.svg" alt />
                </span>
              </div>
            </li>
          </ul>
          <button
            type="button"
            @click="getTaskToPayViaPaytm(taskDetail.Task_id, taskDetail.security_fee[0])"
            v-if="!activePaymentMode"
          >{{$t('payRegisterationFees')}}</button>
          <button
            type="button"
            @click="getTaskToPayNetBanking(taskDetail.Task_id, taskDetail.security_fee[0])"
            v-if="activePaymentMode"
          >{{$t('payRegisterationFees')}}</button>
        </div>
        <div class="get-task" @click="getTaskFunc()" v-if="isEligible.eligible_for == true">
          <p class="task-button" v-if="!isNextTask">{{$t('getTask')}}</p>
          <p class="task-button" v-else>{{$t('getNextTask')}}</p>
        </div>
      </div>
      <div
        v-if="['Dau','Khel91'].includes(taskDetail.task_fam) && ([1,2].includes(callStatus.call_complete) || !callStatus.hasOwnProperty('id'))"
        class="go-to-prod"
      >
        <div v-if="isEligible.eligible_for == false" class="payment-option">
          <ul style="margin-top: -8px;">
            <li class="custom-checkbox">
              <div @click="selectMode('PAYTM')">
                <span class="check-mark" :class="{'active' :!activePaymentMode }"></span>
                <span class="name">Paytm Payment</span>
                <span class="card-img">
                  <img src="../assets/images/paytm.svg" alt />
                </span>
              </div>
            </li>
            <li class="custom-checkbox">
              <div @click="selectMode('NETBANKING')">
                <span class="check-mark" :class="{'active' :activePaymentMode }"></span>
                <span class="name">Debit card / Netbanking</span>
                <span class="card-img">
                  <img src="../assets/images/credit-card.svg" alt />
                </span>
              </div>
            </li>
          </ul>
          <button
            type="button"
            @click="getTaskToPayViaPaytm(taskDetail.Task_id, taskDetail.security_fee[0])"
            v-if="!activePaymentMode"
          >{{$t('payRegisterationFees')}}</button>
          <button
            type="button"
            @click="getTaskToPayNetBanking(taskDetail.Task_id, taskDetail.security_fee[0])"
            v-if="activePaymentMode"
          >{{$t('payRegisterationFees')}}</button>
        </div>
        <div class="get-task" @click="getTaskFunc()" v-if="isEligible.eligible_for == true">
          <p class="task-button" v-if="!isNextTask">{{$t('getTask')}}</p>
          <p class="task-button" v-else>{{$t('getNextTask')}}</p>
        </div>
      </div>

      <div v-if="taskDetail.task_fam === 'Courier91'" class="go-to-prod">
        <div v-if="isEligible.eligible_for == false" class="payment-option">
          <h5 style="text-align:left">{{$t('choosePaymentOption')}}</h5>
          <ul>
            <li class="custom-checkbox">
              <div @click="selectMode('PAYTM')">
                <span class="check-mark" :class="{'active' :!activePaymentMode }"></span>
                <span class="name">Paytm Payment</span>
                <span class="card-img">
                  <img src="../assets/images/paytm.svg" alt />
                </span>
              </div>
            </li>
            <li class="custom-checkbox">
              <div @click="selectMode('NETBANKING')">
                <span class="check-mark" :class="{'active' :activePaymentMode }"></span>
                <span class="name">Debit card / Netbanking</span>
                <span class="card-img">
                  <img src="../assets/images/credit-card.svg" alt />
                </span>
              </div>
            </li>
          </ul>
          <h5 style="text-align:left;margin-top:12px">{{$t('fillRegistrationForm')}}</h5>
          <Courier91 @formData="getFormData" />
        </div>
        <div class="get-success-registered" v-if="isEligible.eligible_for == true">
          <p class="agent-contact-note">
            <img src="../assets/images/check-mark.png" alt />
            {{$t('registered')}}
          </p>
          <p
            class="account-msg"
          >{{$t('mall91AgentWillCallYou')}}</p>
        </div>
      </div>

      <div
        v-if="taskDetail.task_fam === 'Call Center' && callStatus.status === 0"
        class="order_action go-to-prod"
      >
        <h5 style="text-align:left">{{$t('orderDetail')}}</h5>
        <ul class="call_detail_item" v-if="callStatus">
          <li class="inputFeild">
            <label>
              <span>{{$t('OrderId')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callStatus.orderId" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('amount')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callStatus.orderAmount" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('productName')}} :</span>
            </label>
            <textarea :placeholder="$t('name')" v-model="callStatus.itemName" readonly></textarea>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('paymentMode')}} :</span>
            </label>
            <input :placeholder="$t('paymentMode')" v-model="callStatus.PaymentMethod" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callStatus.buyerName" :readonly="!isEditable" />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>

          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input
              :placeholder="$t('phoneNumber')"
              v-model="callStatus.PhoneNumber"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>

          <li class="inputFeild">
            <label>
              <span>{{$t('address')}} :</span>
            </label>
            <textarea
              :placeholder="$t('address')"
              v-model="callStatus.Address"
              cols="auto"
              :readonly="!isEditable"
            ></textarea>
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('city')}} :</span>
            </label>
            <input :placeholder="$t('city')" v-model="callStatus.City" :readonly="!isEditable" />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('state')}} :</span>
            </label>
            <input :placeholder="$t('state')" v-model="callStatus.State" :readonly="!isEditable" />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('postOffice')}} :</span>
            </label>
            <input
              :placeholder="$t('postOffice')"
              v-model="callStatus.PostOffice"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('pincode')}} :</span>
            </label>
            <input
              :placeholder="$t('pincode')"
              v-model="callStatus.Pincode"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
        </ul>
        <div class="call-accepted" v-if="isCallAccepted">
          <p>{{$t('callCompletedOrRejected')}}</p>
          <div style="padding:0 15px">
            <button type="button" @click="callCompleted(callStatus.id)">{{$t('callCompleted')}}</button>
            <button
              type="button"
              class="deny"
              @click="callNotCompleted(callStatus.id)"
            >{{$t('callNotCompleted')}}</button>
            <button
              type="button"
              class="deny"
              @click="callNotCompleted(callStatus.id)"
            >{{$t('callNotPicked')}}</button>
          </div>
        </div>
        <div v-else class="call-accepted">
          <p>{{$t('orderAcceptedOrRejected')}}</p>
          <div style="padding:0 15px">
            <button type="button" @click="acceptedOrder(callStatus.id)">{{$t('orderAccepted')}}</button>
            <button
              type="button"
              class="deny"
              @click="denyOrder(callStatus.id)"
            >{{$t('orderDenied')}}</button>
          </div>
        </div>
      </div>
      <div
        v-if="taskDetail.task_fam === 'Dau' && callStatus.call_complete === 0"
        class="order_action go-to-prod"
      >
        <ul class="call_detail_item" v-if="callStatus">
          <li class="inputFeild" v-if="callStatus.name">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callStatus.name" readonly />
          </li>
          <li v-else class="inputFeild">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('notAvailable')" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input :placeholder="$t('phoneNumber')" v-model="callStatus.phone" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('walletBalance')}} :</span>
            </label>
            <input :placeholder="$t('walletBalance')" v-model="callStatus.mcash_balance" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('mPointBalance')}} :</span>
            </label>
            <input :placeholder="$t('mPointBalance')" v-model="callStatus.wallet_balance" readonly />
          </li>
        </ul>
        <div class="call-accepted" v-if="isCallAccepted" style="padding-top:12px">
          <!-- <p>{{$t('callCompletedOrRejected')}}</p> -->
          <div style="padding:0 15px">
            <button
              type="button"
              @click="balanceChecked(callStatus.id, taskDetail.Task_id)"
            >{{$t('appBalanceChecked')}}</button>
            <button
              type="button"
              class="deny"
              @click="balanceNotChecked(callStatus.id, taskDetail.Task_id)"
            >{{$t('appBalanceNotChecked')}}</button>
            <button
              type="button"
              class="deny"
              @click="balanceNotChecked(callStatus.id, taskDetail.Task_id)"
            >{{$t('callNotPicked')}}</button>
          </div>
        </div>
      </div>
      <div
        v-if="taskDetail.task_fam === 'Khel91' && callStatus.call_complete === 0"
        class="order_action go-to-prod"
      >
        <ul class="call_detail_item" v-if="callStatus">
          <li class="inputFeild" v-if="callStatus.name">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callStatus.name" readonly />
          </li>
          <li v-else class="inputFeild">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('notAvailable')" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input :placeholder="$t('phoneNumber')" v-model="callStatus.phone" readonly />
          </li>
        </ul>
        <div class="call-accepted" v-if="isCallAccepted" style="padding-top:12px">
          <div style="padding:0 15px">
            <button
              type="button"
              @click="gameDownload(callStatus.id, taskDetail.Task_id)"
            >{{$t('gameDownload')}}</button>
            <button
              type="button"
              class="deny"
              @click="gameNotDownload(callStatus.id, taskDetail.Task_id)"
            >{{$t('gameNotDownload')}}</button>
            <button
              type="button"
              class="deny"
              @click="gameNotDownload(callStatus.id, taskDetail.Task_id)"
            >{{$t('callNotPicked')}}</button>
          </div>
        </div>
      </div>

      <div class="task-submit">
        <h2>{{$t('seeInvideo')}}</h2>
        <div class="video-box">
          <iframe
            width="560"
            height="315"
            :src="taskDetail.video"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            v-if="taskDetail.video"
          ></iframe>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/McqKpz1RDIM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            v-else
          ></iframe>
        </div>
        <div
          v-if="!['Call Center','Dau', 'Khel91','Courier91'].includes(taskDetail.task_fam) && notCallFamTask"
        >
          <button
            class="button submit-btn"
            @click="acceptModal = !acceptModal"
          >{{$t('acceptThisTask')}}</button>
          <router-link tag="div" class="next-task" :to="{ path: '/'}">
            <span>{{$t('rejectThisTask')}}</span>
          </router-link>
        </div>
      </div>
    </section>
    <div class="customModal" v-if="acceptModal">
      <div class="modal_dialog">
        <div class="modal_content">
          <h3>{{$t('doYouReallyWantToAccept')}}</h3>
        </div>
        <div class="modal_footer alert_btn">
          <button type="button" class="no" @click="acceptModal = !acceptModal">{{$t('later')}}</button>
          <button type="button" class="yes" @click="acceptTask(taskDetail.Task_id)">{{$t('yes')}}</button>
        </div>
      </div>
    </div>
    <div class="payment_action" v-if="$route.query.success === 'true' && isPayment">
      <div class="order_confirmation success">
        <img src="../assets/images/check-mark-success.gif" alt="payment-success" />
        <span class="congratsText">{{$t('paymentSuccessFull')}}</span>
        <span
          class="close"
          @click="isPayment = !isPayment"
          style="position: absolute;top: 15px;right: 15px;"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="payment_action" v-if="$route.query.success === 'false' && isPayment">
      <div class="order_confirmation success">
        <img src="../assets/images/payment-failed.svg" alt="payment-success" />
        <span class="failedText">{{$t('paymentUnSuccessFull')}}</span>
        <span
          class="close"
          @click="isPayment = !isPayment"
          style="position: absolute;top: 15px;right: 15px;"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
      </div>
    </div>
    <section class="payment_action" v-if="call_detail">
      <div class="find-call">
        <span
          class="close"
          @click="cancelCallPopup(callingDetails.id, taskDetail.Task_id)"
          v-if="callingDetails.hasOwnProperty('id')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
        <div class="call_detail go-to-prod" v-if="taskDetail.task_fam === 'Call Center'">
          <h5>{{$t('orderDetail')}}</h5>
          <ul class="call_detail_item">
            <li>
              <span>{{$t('name')}} :</span>
              {{callingDetails.buyerName}}
            </li>
            <li>
              <span>{{$t('OrderId')}} :</span>
              {{callingDetails.orderId}}
            </li>
            <li>
              <span>{{$t('productName')}} :</span>
              {{callingDetails.itemName}}
            </li>
            <li>
              <span>{{$t('paymentMode')}} :</span>
              {{callingDetails.PaymentMethod}}
            </li>
            <li>
              <span>{{$t('phoneNumber')}} :</span>
              {{callingDetails.PhoneNumber}}
            </li>
            <li>
              <span>{{$t('amount')}} :</span>
              {{callingDetails.orderAmount}}
            </li>
            <li>
              <span>{{$t('address')}} :</span>
              {{callingDetails.Address}}
            </li>
            <li>
              <span>{{$t('city')}} :</span>
              {{callingDetails.City}}
            </li>
            <li>
              <span>{{$t('state')}} :</span>
              {{callingDetails.State}}
            </li>
            <li v-if="callingDetails.PostOffice">
              <span>{{$t('postOffice')}} :</span>
              {{callingDetails.PostOffice}}
            </li>
            <li v-else>
              <span>{{$t('postOffice')}} :</span>
              --
            </li>
            <li>
              <span>{{$t('pincode')}} :</span>
              {{callingDetails.Pincode}}
            </li>
          </ul>
          <button
            type="button"
            @click="makeCall(callingDetails.id)"
            v-if="callingDetails.hasOwnProperty('id') && isEligible.eligible_for == true"
          >
            <span>{{$t('makecall')}}</span>
          </button>
        </div>
        <div class="call_detail go-to-prod" v-if="taskDetail.task_fam === 'Dau'">
          <h5>{{$t('userDetail')}}</h5>
          <ul class="call_detail_item">
            <li v-if="callingDetails.name">
              <span>{{$t('name')}} :</span>
              {{callingDetails.name}}
            </li>
            <li v-else>
              <span>{{$t('name')}} :</span>
              {{$t('notAvailable')}}
            </li>
            <li>
              <span>{{$t('phoneNumber')}} :</span>
              {{callingDetails.phone}}
            </li>
            <li>
              <span>{{$t('walletBalance')}} :</span>
              {{callingDetails.wallet_balance}}
            </li>
            <li>
              <span>{{$t('mPointBalance')}} :</span>
              {{callingDetails.mcash_balance}}
            </li>
          </ul>
          <button
            type="button"
            @click="makeCall(callingDetails.id, taskDetail.Task_id)"
            v-if="callingDetails.hasOwnProperty('id') && isEligible.eligible_for == true"
          >
            <span>{{$t('makecall')}}</span>
          </button>
        </div>
        <div class="call_detail go-to-prod" v-if="taskDetail.task_fam === 'Khel91'">
          <h5>{{$t('userDetail')}}</h5>
          <ul class="call_detail_item">
            <li v-if="callingDetails.name">
              <span>{{$t('name')}} :</span>
              {{callingDetails.name}}
            </li>
            <li v-else>
              <span>{{$t('name')}} :</span>
              {{$t('notAvailable')}}
            </li>
            <li>
              <span>{{$t('phoneNumber')}} :</span>
              {{callingDetails.phone}}
            </li>
          </ul>
          <button
            type="button"
            @click="makeCall(callingDetails.id, )"
            v-if="callingDetails.hasOwnProperty('id') && isEligible.eligible_for == true"
          >
            <span>{{$t('makecall')}}</span>
          </button>
        </div>
      </div>
    </section>

    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <section class="payment_action" v-if="taskNotAllowed">
      <div class="find-call">
        <span class="close" @click="taskNotAllowed = !taskNotAllowed">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
        <div
          class="call_detail go-to-prod"
          style="padding-right:40px;padding-bottom:20px;"
        >{{$t('getTaskAllowedMsg')}}</div>
      </div>
    </section>
  </div>
</template>
<script>
import "../assets/css/task-detail.css";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import CustomToaster from "../components/Common/CustomToaster";
import { SessionHelper, X_AUTH_ID, JWT_TOKEN } from "../utils/session";
import Courier91 from "../components/taskFamily/Courier91";

export default {
  name: "TaskDetail",
  components: {
    CustomToaster,
    Courier91
  },
  data() {
    return {
      taskDetail: [],
      acceptModal: false,
      loading: false,
      isValidDetail: false,
      toasterData: {},
      taskDescription: [],
      isEligible: {},
      callingDetails: {},
      getUserDetail: {},
      call_detail: false,
      isPayment: true,
      callOrderId: {},
      callStatus: {},
      isNextTask: false,
      isCallAccepted: true,
      isEditable: false,
      notCallFamTask: false,
      taskNotAllowed: false,
      activePaymentMode: false,
      isDauAccepted: true,
      lastFamName: "",
      isCourierRegister: false,
      courierFormData: {}
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    goToProdOpen(data) {
      try {
        JSBridgePlugin.genericIntentLaunch(data);
      } catch (err) {
        console.log(err);
      }
    },
    selectMode(value) {
      if (value === "NETBANKING") {
        this.activePaymentMode = !this.activePaymentMode;
      } else {
        this.activePaymentMode = !this.activePaymentMode;
      }
    },
    refreshJwtToken() {
      try {
        _JWT.refereshToken = res => {
          if (res != "fail") {
            this.$cookie.set("JWT-TOKEN", res);
          } else {
            this.loading = false;
          }
        };
        JSBridgePlugin.refreshTokens("_JWT.refereshToken");
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    callCompleted(id) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/call_finished/?call_id=" + id + "&status=" + true,
        "post"
      )
        .then(data => {
          this.isCallAccepted = false;
          this.loading = false;
          this.isEditable = true;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    callNotCompleted(id) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/call_finished/?call_id=" + id + "&status=" + false,
        "post"
      )
        .then(data => {
          this.loading = false;
          this.callStatus = {};
        })
        .catch(err => {
          this.loading = false;
        });
    },
    balanceChecked(id, taskId) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/dau_call_finished/?dau_order_id=" +
          id +
          "&task_id=" +
          taskId +
          "&status=" +
          true,
        "post"
      )
        .then(data => {
          this.isCallAccepted = false;
          this.callStatus = {};
          this.loading = false;
          this.isNextTask = true;
          this.getLastCallStatus();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    balanceNotChecked(id, taskId) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/dau_call_finished/?dau_order_id=" +
          id +
          "&task_id=" +
          taskId +
          "&status=" +
          false,
        "post"
      )
        .then(data => {
          this.loading = false;
          this.callStatus = {};
        })
        .catch(err => {
          this.loading = false;
        });
    },
    gameDownload(id, taskId) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/khel_call_finished/?khel_order_id=" +
          id +
          "&task_id=" +
          taskId +
          "&status=" +
          true,
        "post"
      )
        .then(data => {
          this.isCallAccepted = false;
          this.callStatus = {};
          this.loading = false;
          this.isNextTask = true;
          this.getLastCallStatus();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    gameNotDownload(id, taskId) {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/khel_call_finished/?khel_order_id=" +
          id +
          "&task_id=" +
          taskId +
          "&status=" +
          false,
        "post"
      )
        .then(data => {
          this.loading = false;
          this.callStatus = {};
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getTaskDetail() {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/taskdetails/?task_id=" + this.$route.query.allTaskIndex,
        "get"
      )
        .then(data => {
          this.isEligible = data;
          this.taskDetail = data.data[0];
          if (
            this.isEligible.eligible_for == true &&
            this.taskDetail.task_fam !== "Courier91"
          ) {
            this.getLastCallStatus();
          }
          if (
            this.taskDetail.task_fam !== "Call Center" ||
            this.taskDetail.task_fam !== "Dau"
          ) {
            this.notCallFamTask = true;
          }
          this.taskDescription = data.data[0].task_details[0][0].text.split(
            "\r\n"
          );
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    cancelCallPopup(id, taskid) {
      this.loading = true;
      if (this.taskDetail.task_fam === "Dau") {
        const obj = {
          dau_order_id: id,
          task_id: taskid
        };
        ApiCaller(constant.BASE_API_URL, "tasks/dau_order_active/", "post", obj)
          .then(data => {
            this.loading = false;
            this.call_detail = false;
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else if (this.taskDetail.task_fam === "Call Center") {
        const obj = {
          call_id: id
        };
        ApiCaller(
          constant.BASE_API_URL,
          "tasks/call_order_active/",
          "post",
          obj
        )
          .then(data => {
            this.loading = false;
            this.call_detail = false;
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else if (this.taskDetail.task_fam === "Khel91") {
        const obj = {
          khel_order_id: id
        };
        ApiCaller(
          constant.BASE_API_URL,
          "tasks/khel_order_active/",
          "post",
          obj
        )
          .then(data => {
            this.loading = false;
            this.call_detail = false;
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      }
    },
    getFormData(value) {
      this.loading = true;
      this.courierFormData = value;
      const obj = this.courierFormData;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/courier_partner_registration/?task_id=" +
          this.taskDetail.Task_id,
        "put",
        obj
      )
        .then(data => {
          if (data.success) {
            if (this.activePaymentMode) {
              window.location.href = `${
                constant.BASE_API_URL
              }payment/gateway/?gateway_amount=${
                this.taskDetail.security_fee[0]
              }&Task-Id=${
                this.taskDetail.Task_id
              }&PO=Card&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
              // this.loading = false;
            } else {
              window.location.href = `${
                constant.BASE_API_URL
              }payment/gateway/?gateway_amount=${
                this.taskDetail.security_fee[0]
              }&Task-Id=${
                this.taskDetail.Task_id
              }&x_auth_id=${SessionHelper.getCookie(X_AUTH_ID)}`;
              // this.loading = false;
            }
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    getTaskToPayViaPaytm(id, amount) {
      if (this.taskDetail.task_fam === "Courier91") {
        // this.isCourierRegister = true;
      } else {
        this.loading = true;
        window.location.href = `${
          constant.BASE_API_URL
        }payment/gateway/?gateway_amount=${amount}&Task-Id=${id}&x_auth_id=${SessionHelper.getCookie(
          X_AUTH_ID
        )}`;
      }
    },
    getTaskToPayNetBanking(id, amount) {
      if (this.taskDetail.task_fam === "Courier91") {
        // this.isCourierRegister = true;
      } else {
        this.loading = true;
        window.location.href = `${
          constant.BASE_API_URL
        }payment/gateway/?gateway_amount=${amount}&Task-Id=${id}&PO=Card&x_auth_id=${SessionHelper.getCookie(
          X_AUTH_ID
        )}`;
      }
    },
    getTaskFunc() {
      if (
        [
          "47f64e755012d2865986a027f473d3c3",
          "1ee2e5e34c2886bf91b82adfcea38b4c"
        ].includes(SessionHelper.getCookie(X_AUTH_ID))
      ) {
        this.getCallingDetails();
        this.isCallAccepted = true;
      } else {
        var _ = new Date();
        if (_.getHours() < 20 && _.getHours() >= 9) {
          this.getCallingDetails();
          this.isCallAccepted = true;
        } else {
          this.taskNotAllowed = true;
        }
      }
    },
    makeCall(id, taskid) {
      this.loading = true;
      if (this.callingDetails) {
        if (this.taskDetail.task_fam === "Dau") {
          const obj = {
            dau_order_id: id,
            task_id: taskid
          };
          ApiCaller(constant.BASE_API_URL, "tasks/daucall/", "post", obj)
            .then(data => {
              this.loading = false;
              this.call_detail = false;
              this.isEditable = false;
              try {
                JSBridgePlugin.genericIntentLaunch(
                  `tel:+91${this.callingDetails.phone}`
                );
              } catch {
                console.log("error");
              }
              this.getLastCallStatus();
            })
            .catch(err => {
              this.call_detail = false;
              this.loading = false;
            });
        } else if (this.taskDetail.task_fam === "Call Center") {
          const obj = {
            call_id: id
          };
          ApiCaller(constant.BASE_API_URL, "tasks/makecall/", "post", obj)
            .then(data => {
              this.loading = false;
              this.call_detail = false;
              this.isEditable = false;
              try {
                JSBridgePlugin.genericIntentLaunch(
                  `tel:+91${this.callingDetails.PhoneNumber}`
                );
              } catch {
                console.log("error");
              }
              this.getLastCallStatus();
            })
            .catch(err => {
              this.call_detail = false;
              this.loading = false;
            });
        } else if (this.taskDetail.task_fam === "Khel91") {
          const obj = {
            khel_order_id: id
          };
          ApiCaller(constant.BASE_API_URL, "tasks/khelcall/", "post", obj)
            .then(data => {
              this.loading = false;
              this.call_detail = false;
              this.isEditable = false;
              try {
                JSBridgePlugin.genericIntentLaunch(
                  `tel:+91${this.callingDetails.phone}`
                );
              } catch {
                console.log("error");
              }
              this.getLastCallStatus();
            })
            .catch(err => {
              this.call_detail = false;
              this.loading = false;
            });
        }
      }
    },
    getCallingDetails() {
      this.loading = true;
      if (this.taskDetail.task_fam === "Dau") {
        this.lastFamName = "dau_calling_details";
      } else if (this.taskDetail.task_fam === "Call Center") {
        this.lastFamName = "calling_details";
      } else if (this.taskDetail.task_fam === "Khel91") {
        this.lastFamName = "khel_calling_details";
      }
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/" +
          this.lastFamName +
          "/?task_id=" +
          this.$route.query.allTaskIndex,
        "get"
      )
        .then(data => {
          this.callingDetails = data.data;
          this.call_detail = true;
          this.loading = false;
          this.refreshJwtToken();
        })
        .catch(err => {
          this.loading = false;
          if (err.response.data.errorCodes[0] == "task is full") {
            this.toasterData = {
              msg: this.$t("newTaskWillBeAvailable"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
          }
        });
    },
    validateFields() {
      const obj = this.callStatus;
      if (
        !obj.buyerName ||
        !obj.PhoneNumber ||
        !obj.Address ||
        !obj.City ||
        !obj.State ||
        !obj.PostOffice ||
        !obj.Pincode
      ) {
        this.toasterData = {
          msg: this.$t("enterAllFeilds"),
          color: "#e51c24",
          iconName: "close"
        };
        this.isValidDetail = true;
        return false;
      } else {
        if (obj.buyerName.length <= 3) {
          this.toasterData = {
            msg: this.$t("enterValidName"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.PhoneNumber.length != "") {
          if (
            !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(obj.PhoneNumber)
          ) {
            this.toasterData = {
              msg: this.$t("enterValidMobileNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        if (
          obj.Address.length <= 4 &&
          obj.City.length <= 4 &&
          obj.State.length <= 4 &&
          obj.PostOffice.length <= 4
        ) {
          this.toasterData = {
            msg: this.$t("enterValidAddress"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.Pincode.length != "") {
          if (!new RegExp(/^[1-9][0-9]{5}$/g).test(obj.Pincode)) {
            this.toasterData = {
              msg: this.$t("enterValidPinNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        return true;
      }
    },
    acceptedOrder(id) {
      if (this.validateFields()) {
        this.loading = true;
        const obj = {
          call_id: id,
          status: 1,
          updated_data: this.callStatus
        };
        ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
          .then(data => {
            if (data.success) {
              this.call_detail = false;
              this.isEditable = false;
              this.isNextTask = true;
              this.getLastCallStatus();
            }
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    denyOrder(id) {
      if (this.validateFields()) {
        this.loading = true;
        const obj = {
          call_id: id,
          status: 2,
          updated_data: this.callStatus
        };
        ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
          .then(data => {
            this.loading = false;
            if (data.success) {
              this.call_detail = false;
              this.isEditable = false;
              this.isNextTask = true;
              this.getLastCallStatus();
            }
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    acceptTask(id) {
      this.loading = true;
      const obj = {
        task_id: id
      };
      ApiCaller(constant.BASE_API_URL, "tasks/orders/", "post", obj)
        .then(data => {
          this.loading = false;
          this.acceptModal = false;
          this.$router.push("/");
        })
        .catch(err => {
          this.loading = false;
          this.acceptModal = false;
          this.toasterData = {
            msg: err.response.data.message,
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
        });
    },
    getLastCallStatus() {
      this.loading = true;
      if (this.taskDetail.task_fam === "Dau") {
        this.lastFamName = "dau_last_call";
      } else if (this.taskDetail.task_fam === "Call Center") {
        this.lastFamName = "last_call";
      } else if (this.taskDetail.task_fam === "Khel91") {
        this.lastFamName = "khel_last_call";
      }
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/" +
          this.lastFamName +
          "/?task_id=" +
          this.$route.query.allTaskIndex,
        "get"
      )
        .then(data => {
          this.callStatus = data.data;
          if (data.data.call_complete === 1) {
            this.isCallAccepted = false;
            this.isEditable = true;
          }
          this.loading = false;
          this.refreshJwtToken();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {
    this.getTaskDetail();
    __native_money91._onResume = function() {
      _this.getTaskDetail();
    };
  }
};
</script>
<style scoped>
.isDisable {
  opacity: 0.5;
}
.payment-option button {
  margin-top: 8px;
}
.agent-contact-note {
  border: 0;
  color: #000;
  width: auto;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 1.25em;
  font-weight: 600;
  justify-content: flex-start;
}
.agent-contact-note img {
  width: 25px;
  margin-right: 8px;
}
.account-msg {
  margin-top: 8px;
  color: #5c5959;
  font-weight: 600;
  text-align: left;
}
.get-success-registered{
      background: #f443361c;
    padding: 8px;
}
</style>